import React from 'react';
import "./sideicons.css";
import call from "../assets/testingimages/projecticons/telephone-call.png";
import whatsapp from "../assets/testingimages/projecticons/whatsapp.png";

function Sideicons() {
  return (
     <section>
  <div className="main-icons">
    <ul className="first">
      <li className="color1">
        <a href="tel:+916380866249">
      <p className="icon-text">
  <span>Call</span>
  <span>+91 6380866249</span>
</p>
          {/* </p> */}
          <img
            src={call}
            width="20"
            height="20"
            className="img-fluid"
            alt="Call Icon"
          />
        </a>
      </li>

      <li className="color2">
        <a
          href="https://api.whatsapp.com/send?phone=916380866249"
          target="_blank"
          rel="noopener noreferrer"
        >
          <p className="icon-text">
           <span>Whatsapp</span> 
            {/* <br /> */}
           <span>+91 6380866249</span> 
          </p>
          <img
            src={whatsapp}
            width="24"
            height="24"
            className="img-fluid"
            alt="WhatsApp Icon"
          />
        </a>
      </li>
    </ul>
  </div>
</section>
  )
}

export default Sideicons
